export const C = {
  bg: "#0F172A",
  card: "#1E293B",
  card2: "#334155",
  text: "#FFFFFF",
  sub: "#CBD5E1",
  muted: "#94A3B8",
  amber: "#F59E0B",
  amberDark: "#D97706",
  green: "#10B981",
  red: "#EF4444",
  blue: "#3B82F6",
  border: "#334155",
  borderStrong: "#475569",
  black: "#000000",
};

export const S = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32, xxxl: 48 };
export const R = { sm: 4, md: 8, lg: 12, pill: 999 };
